/* Publish by EComposer at 2024-07-23 03:39:34*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-al04doybbug"]=  window.__ectimmers["ecom-al04doybbug"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-al04doybbug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-al04doybbug', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-88m77ljqypo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-88m77ljqypo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6gw41coklns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6gw41coklns', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9h1h9w19fha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9h1h9w19fha', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gf7r2jbxor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gf7r2jbxor', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fjoqcv4orn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fjoqcv4orn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfw326bvfil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfw326bvfil', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-co8ko4aq8s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-co8ko4aq8s7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mqcgn5mnwh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqcgn5mnwh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3cqtzazot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3cqtzazot', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fdrlrcuboo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fdrlrcuboo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w7fo7hxdmxt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7fo7hxdmxt', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hssgblds0x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hssgblds0x', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7zcl0bhkk9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7zcl0bhkk9r', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24az1xru7su').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24az1xru7su', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}